// The values must be sorted for arbitrary media queries to work, so the
// component specific ones can't live separately.
export const breakpoints = {
	xs: 0,
	sm: 600,
	headerRow: 850, // Component specific
	md: 1024,
	lg: 1366,
	xl: 1644,
	full: 1920,
} as const;

export type Breakpoint = keyof typeof breakpoints;

// Breakpoints for container queries.
// NOTE! Also used for size utilities like `max-w`, so be careful with names
// to avoid collisions. E.g. including `full` to match above breakpoints will
// make `max-w-full` into 1920px instead of 100%.
export const containers = {
	sm: 600,
	basketMd: 850, // Component specific
	md: 1024,
	lg: 1366,
	xl: 1644,
} as const;
